import React, { useState, useEffect } from "react";
import { Button, Card, CardBody, Container, Input } from "reactstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { usermanageService } from "../../../services/usermanageService";

import "../../../assets/css/custom.css";
import Header from "components/Headers/Header.js";

const PhaseTargets = (props) => {
  const [targets, setTargets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(null);

  useEffect(() => {
    get_targets();
    return () => {
      setTargets([]);
    };
  }, []);

  function get_targets() {
    setLoading(true);
    usermanageService.getPhaseTargets().then((response) => {
      setLoading(false);
      if (response && response.status == 200) {
        setTargets(response.data.targets);
      } else {
        toast.error(
          (response && response.data && response.data.message) ||
            "Unable to load phase targets."
        );
      }
    });
  }

  function inputhandler(phase_id, value) {
    setTargets((prev) =>
      prev.map((row) =>
        row.phase_id == phase_id ? { ...row, daily_target: value } : row
      )
    );
  }

  function savetarget(row) {
    const value = parseInt(row.daily_target, 10);
    if (isNaN(value) || value < 1) {
      toast.error("Daily target must be a whole number of 1 or more.");
      return;
    }

    setSaving(row.phase_id);
    usermanageService.updatePhaseTarget(row.phase_id, value).then((response) => {
      setSaving(null);
      if (response && response.status == 200) {
        toast.success(response.data.message);
      } else {
        toast.error(
          (response && response.data && response.data.message) ||
            "Unable to update the daily target."
        );
        get_targets();
      }
    });
  }

  const columns = [
    {
      name: "Sr No",
      selector: (row) => row.phase_id,
      width: "90px",
    },
    {
      name: "Phase",
      selector: (row) => row.phase_name,
      wrap: true,
      grow: 2,
    },
    {
      name: "Daily Target",
      selector: (row) => row.daily_target,
      cell: (row) => (
        <Input
          type="number"
          min="1"
          step="1"
          value={row.daily_target}
          style={{ width: "110px", color: "#4a4444" }}
          onChange={(e) => inputhandler(row.phase_id, e.target.value)}
        />
      ),
      width: "160px",
    },
    {
      name: "Action",
      selector: (row) => row.phase_id,
      cell: (row) => (
        <Button
          color="success"
          size="sm"
          disabled={saving == row.phase_id}
          onClick={savetarget.bind(this, row)}
        >
          {saving == row.phase_id ? "Saving..." : "Save"}
        </Button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "72px", // override the row height
      },
    },
    headCells: {
      style: {
        background: "#ebebeb",
        paddingLeft: "8px", // override the cell padding for head cells
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
      },
    },
  };

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <div className="row">
          <div className="col-xl-12">
            <div class="row">
              <div class="col-md-8">
                <h2>Phase Targets</h2>
                <p className="text-muted">
                  Daily processing capacity per phase. The Daily TAT report uses
                  it as TAT = backlog / daily target.
                </p>
              </div>
            </div>
            <br />
          </div>
          <div className="col-xl-12">
            <Card className="shadow">
              <CardBody>
                <DataTable
                  columns={columns}
                  data={targets}
                  customStyles={customStyles}
                  progressPending={loading}
                  noDataComponent="No phase targets configured."
                  pagination
                />
              </CardBody>
            </Card>
          </div>
        </div>
      </Container>
    </>
  );
};

export default PhaseTargets;
